$(document).ready(function(){

    //nav menu spacing
    $("<div class='menu-spacer'></div>").insertAfter("nav.header__inline-menu li:nth-child(2)") 

    $("p.shop-page-header.hide-desktop").click(function(){
      $(".menu-links-wrapper").slideToggle();  
      $("span.open-menu-links").toggleClass("open");  
    });

    $(document).on('click','.shop-page-header.Show_Ipad.Show_Mobile',function(){
      $(".menu-links-wrapper").toggleClass("active"); 
    });

    $(".product__description.Show_Ipad").click(function(){
      $(".product__description.Show_Ipad .content").slideToggle();  
    });
  
    // Add smooth scrolling
	var hashTagActive = "";
	$(".smooth-scroll").on("click touchstart", function (event) {
		if (hashTagActive != this.hash) { //this will prevent if the user click several times the same link to freeze the scroll.
			event.preventDefault();
			//calculate destination place
			var dest = 0;
			if ($(this.hash).offset().top > $(document).height() - $(window).height()) {
				dest = $(document).height() - $(window).height();
			} else {
				dest = $(this.hash).offset().top;
			}
			//go to destination
			$('html,body').animate({
				scrollTop: dest
			}, 2000, 'swing');
			hashTagActive = this.hash;
		}
	});
});